module.exports = {"610423001":"泾干街道","610423101":"永乐镇","610423102":"云阳镇","610423103":"桥底镇","610423104":"王桥镇","610423105":"口镇","610423107":"三渠镇","610423108":"高庄镇","610423111":"太平镇","610423112":"崇文镇","610423113":"安吴镇","610423114":"兴隆镇","610423115":"中张镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610423.json
// module id = 2947
// module chunks = 0